import React from 'react';
import { ChallengeDescriptionSectionContent } from 'src/types/shared/Challenge';

const WYSIWYG: React.FC<WYSIWYGProps> = ({ data }) => {
    return (
        <>
            {data.title && <h3>{data.title}</h3>}
            <div className="wysiwyg" dangerouslySetInnerHTML={{ __html: data.content }} />
        </>
    );
};

interface WYSIWYGProps {
    data: ChallengeDescriptionSectionContent;
}

export default WYSIWYG;
